import {ITableColumn} from '../../types';
import {ReactNode} from 'react';
import {Account} from "../accounts/types.ts";
import {Application} from "../applications/types.ts";


export enum AccountApplicationStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}

export type AccountApplicationFormType = {
                                             accountId?: string
                                             applicationId?: string,
                                         } & { [key: string]: any }


export type AccountApplication = {
                                     id: string,
                                     accountId: string,
                                     account: Account,
                                     applicationId: string,
                                     application: Application,
                                     accountApplicationStatus: AccountApplicationStatus,
                                     createdByUsername?: string,
                                     createdBy?: { givenName: string, familyName: string },
                                     managedByUsername?: string
                                     managedBy?: { givenName: string, familyName: string },
                                     created?: string,
                                     updated?: string,
                                 } & { [key: string]: any }


export interface IAccountApplicationTableColumn extends ITableColumn {
    render?: (item: AccountApplication) => ReactNode;
}


export type ListAccountApplications = {
    listAccountApplications: { items: AccountApplication[], nextToken?: string | null }
}

export type GetAccountApplication = {
    getAccountApplication: AccountApplication
}

export type CreateAccountApplication = {
    createAccountApplication: AccountApplication
}

export type UpdateAccountApplication = {
    updateAccountApplication: AccountApplication
}

export type DeleteAccountApplication = {
    deleteAccountApplication: string
}

export type AccountApplicationRecordFormProps = {
    record: AccountApplication,
    handleSubmit: (values: AccountApplication) => void
    handleCancel: () => void
}
